import api from "./api";

const VehicleSummaryReportService = {
  getFilterOptions: async (companyId) => {
    try {
      const res = await api.get("/vehicleSummaryReport/filters", {
        params: { companyId }
      });
      return res.data;
    } catch (err) {
      console.error("Vehicle Summary Report Filters Error:", err);
      return { status: false, data: { projects: [], vehicleTypes: [], vehicles: [], relations: [] } };
    }
  },

  getVehicleSummaryReport: async ({
    companyId,
    vehicleId,
    vehicleTypeId,
    projectId,
    fromDate,
    toDate
  }) => {
    try {
      const res = await api.get("/vehicleSummaryReport/details", {
        params: {
          companyId,
          vehicleId: vehicleId || null,
          vehicleTypeId: vehicleTypeId || null,
          projectId: projectId || null,
          fromDate: fromDate || null,
          toDate: toDate || null
        }
      });
      return res.data;
    } catch (err) {
      console.error("Vehicle Summary Report Details Error:", err);
      return { status: false, message: err.message };
    }
  }
};

export default VehicleSummaryReportService;
